import {FiSearch} from "react-icons/fi";
import {Link} from "react-router";

import Button from "@/components/button/Button.tsx";
import {CDNImage} from "@/components/cdnImage/CDNImage.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {IsItDownServiceStatus, PublicProfile} from "@/lib/types/isitdown.ts";

import {IsItDownStatusBadge} from "../isitdownstatusbadge/IsItDownStatusBadge.tsx";

import styles from "./IsItDownTable.module.scss";

interface IsItDownTableProps {
  items: PublicProfile[];
  loading: boolean;
  title?: string;
}

export const IsItDownTable = ({items, loading, title}: IsItDownTableProps) => {
  const getItemClass = (status: IsItDownServiceStatus) => {
    switch (status) {
      case IsItDownServiceStatus.UP:
        return styles.up;
      case IsItDownServiceStatus.DOWN:
        return styles.outage;
      case IsItDownServiceStatus.MAINTENANCE:
        return styles.up;
    }
  };

  return (
    <div className={`${styles.table} row`} id="profiles-list">
      {items && items.length > 0 && (
        <div className="row d-flex px-0">
          {title && <h3 className="marketingTextS3Bold mb-4">{title}</h3>}
          {items.map((item, index) => (
            <div
              key={`${title}-isitdown-table-item-${item.id}`}
              className={`${styles.column} col-md-6 mb-3 ${index % 2 !== 0 && "pe-0"}`}
            >
              <Link
                to={`/${item.slug}`}
                className={`${styles.item} ${getItemClass(item.service_status)} d-flex align-items-center pulse-bg-gray-50`}
              >
                <div className={`${styles.image} d-flex align-items-center flex-shrink-0`}>
                  <CDNImage
                    src={item.image}
                    domain={item.slug}
                    alt={`View ${item.slug} outages and uptime`}
                    title={item.slug}
                  />
                </div>
                <div className={`${styles.slug} pulseTextBodyBold`}>{item.name || item.slug}</div>
                <IsItDownStatusBadge serviceStatus={item.service_status} />
              </Link>
            </div>
          ))}
        </div>
      )}
      {items.length === 0 && !loading && (
        <div className={styles.noServicesContainer}>
          <Icon icon={FiSearch} className="pulse-color-gray-500 mb-2" />
          <div className="pulseTextH3Bold">No service found.</div>
          <Button
            as={Link}
            to="https://feedback.uptime.com"
            target="_blank"
            variant="marketingPrimary"
            size="marketingLarge"
          >
            Request Service
          </Button>
        </div>
      )}
    </div>
  );
};
